module.exports = __webpack_public_path__ + "static/media/eComicScreenPlus-00_2x.eb302181.png";